<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                href="https://admin.ordredespharmaciens.sn/api/v1/sponsors/exportsponsors"
                target="_blank"
                download
              > 
                <span class="text-nowrap">Exporter</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refSponsorsListTable"
        class="position-relative"
        :items="fetchSponsors"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <template #cell(fullName)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-primary`"
              />
            </template>
            <b-link
               :to="{ name: 'transactions-view', params: { userData: data.item } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <!-- <small class="text-muted">@{{ data.item.username }}</small> -->
          </b-media>
        </template>

       <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveSponsorStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>
     
        <!-- Column: Actions -->
         <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content  v-if="data.item.status === 'PENDING'">
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
             <b-dropdown-item  @click="confirmerSponsor(data.item.id)">
              <feather-icon icon="CheckIcon" />
              <span class="align-middle ml-50">Confirmer</span>
            </b-dropdown-item>
            <b-dropdown-item @click="annulerSponsor(data.item.id)">
              <feather-icon icon="XIcon" />
              <span class="align-middle ml-50">Annuler</span>
            </b-dropdown-item>
           
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select' 
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
// import UsersListFilters from './UsersListFilters.vue'
import useSponsorsList from './useSponsorsList'
import sponsorsStoreModule from './sponsorsStoreModule'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // UsersListFilters,
    // UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {
    const SPONSOR_APP_STORE_MODULE_NAME = 'app-sponsors'

    // Register module
    if (!store.hasModule(SPONSOR_APP_STORE_MODULE_NAME)) store.registerModule(SPONSOR_APP_STORE_MODULE_NAME, sponsorsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SPONSOR_APP_STORE_MODULE_NAME)) store.unregisterModule(SPONSOR_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)


    const {
      fetchSponsors,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSponsorsListTable,
      resolveSponsorStatusVariant,
      refetchData

    } = useSponsorsList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchSponsors,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refSponsorsListTable,
      refetchData,
      resolveSponsorStatusVariant,
      // Filter
      avatarText,

    }
  },
  methods : { 
      exportExcel(){
        //contacter l'api pour download fichier excel
      try {
          axios.delete('https://admin.ordredespharmaciens.sn/api/v1/dashboard/exportparticipants').then(res => { 
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Articles`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `Votre article a été retiré !`,
              },
            })
            })
            setTimeout(() => {
                window.location.reload()
            }, 2000);
          
        } catch (error) {
          console.log("error", error);
        }

      },
      format_date(value){
        if (value) {
           return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      confirmerSponsor(id) {
        try {
          axios.patch('https://admin.ordredespharmaciens.sn/api/v1/sponsors/confirmer/'+ id).then(res => { 
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Articles`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `La reservation de stand a été confirmé !`,
              },
            })
             setTimeout(() => {
                window.location.reload()
            }, 2000);
          })
            
            // 
        } catch (error) {
          console.log("error", error);
        }
      },
      annulerSponsor(id) {
        try {
          axios.patch('https://admin.ordredespharmaciens.sn/api/v1/sponsors/annuler/'+ id).then(res => { 
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Articles`,
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: `La reservation de stand a été annulé !`,
              },
            })
            window.location.reload()
          })
            
            // 
        } catch (error) {
          console.log("error", error);
        }
      }
   }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
